var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3634 3.49242C10.8862 3.92982 10.4272 4.36383 9.94992 4.78089C9.81878 4.89617 9.64391 5.00128 9.47269 5.03519C8.99182 5.13013 8.57287 4.80462 8.56923 4.34349C8.56194 3.12961 8.56194 1.91912 8.56923 0.705248C8.57287 0.301753 8.90438 -2.04402e-05 9.3379 -2.04402e-05C10.6275 -0.00341116 11.9208 -0.00341116 13.2104 -2.04402e-05C13.5528 -2.04402e-05 13.8042 0.152562 13.9354 0.447554C14.0665 0.742546 13.9973 1.01719 13.7568 1.24098C13.3707 1.6004 12.9809 1.95303 12.5911 2.30906C12.5437 2.35314 12.4818 2.38026 12.449 2.404C12.7004 2.78037 12.9481 3.10927 13.1485 3.4619C15.3743 7.35783 12.8497 12.1523 8.17943 12.905C4.29965 13.5289 0.623875 11.0469 0.0701408 7.43243C-0.425306 4.17395 1.74956 1.09857 5.15211 0.227157C5.68034 0.0915288 6.092 0.349223 6.20493 0.698467C6.32151 1.06805 6.09564 1.4885 5.56012 1.6343C3.74956 2.12257 2.50366 3.20421 1.87342 4.85887C0.762308 7.77489 2.81695 10.9927 6.08836 11.4809C9.03918 11.9217 11.7386 10.1959 12.3288 7.45955C12.6348 6.03884 12.3033 4.73003 11.4071 3.54328C11.3962 3.52632 11.378 3.50937 11.3634 3.49242Z",
    fill: "#42328A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.b0c00477c978e6cd0bd7f5db33dfc5cf.svg";
export { ForwardRef as ReactComponent };